import React from "react";

const SellerBtn = () => <button>Farmer Login</button>;

export default SellerBtn;